import React, { useState } from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import * as dateFns from 'date-fns';
import { message, notification } from 'antd';

import { FILTER_KEYS, ON_EXPORT_ALERT, YEARS } from '../../config/constants';
import FilterAccountTab from './FilterAccountTab';
import CustomerPlayerTable from '../../components/Customers/CustomerPlayerTable';
import { fileDownload, getFile, getTeamProps, paramBuilder } from '../../helpers';
import { SERVER } from '../../config/server.config';
import { usePlayersDispatch, useFiltersDispatch, useFiltersState, useUserDispatch, useUserState } from '../../store/hooks';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { useRouter } from '../../helpers/customHooks';

import '../Schedule/Badge/styles.scss';
import DatePicker from 'components/Shared/DatePicker/DatePicker';

export default () => {

  const { specificScope, history } = useRouter();
  const { changeFilterData } = useFiltersDispatch();
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
  const { getCustomerPlayers } = usePlayersDispatch();
  const user = useUserState();
  const day = new Date();
  const {
    [FILTER_KEYS.YEAR]: year,
    [FILTER_KEYS.TEAM_ID]: teamIdSelected = user.teamId
  } = useFiltersState(specificScope, FILTER_KEYS.YEAR, FILTER_KEYS.TEAM_ID);
  const league = (getTeamProps(teamIdSelected) || { league: '' }).league;
  const [date, setDate]= useState(day);
  /*
   * Function to export Bulk CSV for team
   */
  // Exports Notifications
  const notificationKey = 'downloadFinished';
  const notificationDownload = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download In Progress',
      description:
        `Your file ${name} is being processed.`,
      duration: 0,
      icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadFinish = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download Finished',
      description:`Your file ${name} has been downloaded successfully.`,
      duration: 4,
      icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadError = (name:string) => {
    const args = {
      key: notificationKey,
      message: `Error downloading file ${name}`,
      duration: 4,
      icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
    };
    notification.open(args);
  };
  const exportBulkCSVForTeam = async (customer: string, bulkDataType: string) => {
    // based on exportBulkCSV on CustomerPlayerTable.jsx
    if (year) {
      notificationDownload(`${customer}_bulk_team.csv`);
      fileIsDownloading(true);
      const yearSelected = year;
      const compareRange = `${dateFns.format(new Date(yearSelected, 2, 1), 'yyyyMMdd')}-${dateFns.format(dateFns.subDays(new Date(yearSelected + 1, 2, 1), 1), 'yyyyMMdd')}`;
      const localDate = new Date();
      const params: { [key: string]: number } = {};
      params['tzOffset'] = -localDate.getTimezoneOffset();
      const materialize = 'no';
      const sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      };
      let done;    
        do{
          done = await fileDownload (SERVER.CSV_REPORT_BULKDATA_TEAMS(customer, bulkDataType, compareRange) + '&' + paramBuilder(params)+ `&materialize=${materialize}`, `${customer}_bulk_team.csv`);
          if(done === 0){
            await sleep(10);
          }else{
            await sleep(5000);
          } 
        }while(done === 1);
        if(done === 0){
          const materialize = 'yes';
          await getFile (SERVER.CSV_REPORT_BULKDATA_TEAMS(customer, bulkDataType, compareRange) + '&' + paramBuilder(params)+ `&materialize=${materialize}`, `${customer}_bulk_team.csv`);
          fileIsDownloading(false);
          notificationDownloadFinish(`${customer}_bulk_team.csv`);
        }else{
          fileIsDownloading(false);
          notificationDownloadError(`${customer}_bulk.csv`);
        }
    } else {
      fileIsDownloading(false);
      message.warning({
        content: ON_EXPORT_ALERT,
        className: 'antd-message-alert'
      });
    }
  };

  return (
    <>
      <Row>
        <Col lg={12} xs={12} style={{ height: 'calc(100vh - 110px)' }}>
          <div className="head-account">
             <h5>Player Zone Settings</h5>
            <div className="account-01">
              <h6>DOWNLOAD BULK TEAM DATA</h6>
              <label> Select Year</label>
              <Dropdown className="a-select">
                <Dropdown.Toggle id="dropdown-basic" className="btn-gray-l">
                  {year ? year : 'Select'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {YEARS.map((year) => (
                    <Dropdown.Item onClick={() => changeFilterData(year, FILTER_KEYS.YEAR)()} key={year}>
                      {year}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="a-export">
                <Dropdown.Toggle id="dropdown-basic" className="btn-blue" disabled={download}>
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => exportBulkCSVForTeam(teamIdSelected, 'practices')} target={'_blank'}>
                    Practice Data Only
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportBulkCSVForTeam(teamIdSelected, 'games')} target={'_blank'}>
                    Game Data Only
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => exportBulkCSVForTeam(teamIdSelected, 'practices,games')} target={'_blank'}
                  >
                    Practice/Game Combined
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

    <div className="account-03">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="b-t">
          <FilterAccountTab
            loadData={() => getCustomerPlayers(teamIdSelected, league)}
            teamIdSelected={teamIdSelected}
            />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h6 style={{ marginTop: '11px', fontSize: '16px' }}>Player Custom Zones for</h6>
          <div className="timep-custom" style={{ marginLeft: '5px' }}>
            <DatePicker date={date} setDate={setDate} isCustomZone={true} />
          </div>
        </div>
      </div>
    </div>
          <div
            style={{
              height: 'calc(100vh - 265px)',
              position: 'relative',
              border: '2px solid rgba(219, 225, 229, 0.6)'
            }}
          >
            <div style={{ height: '100%' }}>
              <CustomerPlayerTable teamId={teamIdSelected} league={league} selectedDate={date}/>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
